var exports = {
  "k": "xe564cbfb--0c4949--container",
};

module.exports = exports;
